import { DATAPARAMETERS } from './dataParamsEnum'

export default {
  props: {
    dataset: {
      type: DOMStringMap,
    },
  },
  data() {
    return {
      // all data will be passed through 1 object through the dataset attribute [data-adacado-dataset]
      adacadoDataset:
        (this.dataset && this.dataset.adacadoDataset && JSON.parse(this.dataset.adacadoDataset)) || undefined,
      currentUrl: window.location.pathname,
    }
  },
  methods: {
    // Given a list of parameters (arr) try to retrieve all of them from either
    // a parent-passed dataset or otherwise the url.  Return an error if either
    // is incomplete.  This is a wrapper(syntactic sugar) for $getAdacadoParamsFromUrl and $getAdacadoDataSetParam
    // This method is so name and prefixed with $ to remind future dev that this
    // function is not native Vue and comes from this mixin.
    $getAdacadoParams(paramList) {
      if (!Array.isArray(paramList)) {
        return { error: 'parameter.getParams(): paramList is not an array'}
      }
      let parameters = {}
      let error = ''

      // First try retrieving all parameters from parent passed dataset
      paramList.map(p => {
        parameters[p] = this.$getAdacadoDataSetParam(p)
      })

      // If any parameters not found, try retrieving all from Url
      if (Object.values(parameters).some(e => e === undefined )) {
        paramList.map(p => {
          parameters[p] = this.$getAdacadoUrlParam(p)
        })
      }

      // Finally, if any parameters still not found, return error
      const missing = Object.entries(parameters).filter( e => e[1] === undefined )
      if (missing.length) {
        parameters = {}
        error = `parameter.getParams(): required parameters missing: ${missing.map( e =>e[0] ).join(',')}`
      }

      return {
        ...parameters,
        error
      }
    },


    $getAdacadoParamsFromUrl() {
      let result = {}
      const paramsAndPathNameFromUrl = this.currentUrl.split('page/')
      if (paramsAndPathNameFromUrl.length > 1 && paramsAndPathNameFromUrl[1]) {
        const paramsFromUrl = paramsAndPathNameFromUrl[1].split('/')
        for (let i = 0; i < paramsFromUrl.length; i += 2) {
          result[paramsFromUrl[i]] = paramsFromUrl[i + 1]
        }
      }
      return result
    },

    // returns value of specified dataset's key if it is a valid enum data parameter
    // eg. $getAdacadoDataSetParam(dataSetObject, 'ADVERTISERID') will return the value of key ai in the dataset
    //
    // @return STRING
    $getAdacadoDataSetParam(param) {
      if (this.adacadoDataset) return this.adacadoDataset[DATAPARAMETERS[param]]
      else return undefined
    },

    // returns value of specified url's key if it is a valid enum data parameter
    // eg. $getAdacadoUrlParam('ADVERTISERID') will return the value of key ai in the url
    //
    // @return ANY TYPE
    $getAdacadoUrlParam(param) {
      const dataParams = this.$getAdacadoParamsFromUrl()
      if (dataParams && dataParams[DATAPARAMETERS[param]]) {
        try {
          // if value is able to be parsed (eg. number, boolean) return parsed value
          const parseData = JSON.parse(dataParams[DATAPARAMETERS[param]])
          return parseData
        } catch {
          // if parse failed (eg. string) return as is without failing
          return dataParams[DATAPARAMETERS[param]]
        }
      }
      // the parameter you are looking for is not standardized
      return undefined
    },

    // given a dataset object, constructs a adacado standard format dataset object to pass as prop to child FEMS
    // eg. putIntoDataSet({ ADVERTISERID: 1234, CAMPAIGNID: 4567 })
    // will return { "ai": 1234, "ci": 4567 }
    //
    // @return OBJECT
    $constructAdacadoDataset(argObj) {
      const obj = {}
      for (const key of Object.keys(argObj)) {
        if (DATAPARAMETERS[key]) {
          obj[DATAPARAMETERS[key]] = argObj[key]
        } else {
          // any non standard key-values will still be added to dataset
          obj[key] = argObj[key]
        }
      }
      return JSON.stringify(obj)
    },

    // Take an existing dataset obj (obj or string) and set its property "key" to val
    // Reserved enumerated key names as defined in emum js file are also handled like
    // they would be in constructor method above
    //
    // @return STRING or OBJECT with new key/value
    $setAdacadoDatasetParam(datasetStr, key, val) {
      if (datasetStr === undefined || !key || val === undefined) return

      try {
        const dataset = typeof datasetStr === 'string' ? JSON.parse(datasetStr) : datasetStr
        dataset[DATAPARAMETERS[key]||key] = val
        return (typeof datasetStr === 'string' ? JSON.stringify(dataset) : dataset)
      } catch (e) {
        console.error('Parameter Mixin: Error setting adacado dataset param :', e)
        return datasetStr
      }
    }
  },
}